import React from "react";
import { Page, Document, Image, StyleSheet } from "@react-pdf/renderer";
import DetailPdfTitle from "./components/DetailPdfTitle";
import DetailPdfTo from "./components/DetailPdfTo";
import DetailPdfNo from "./components/DetailPdfNo";
import DetailPdfItemsTable from "./components/DetailPdfItemsTable";
import logo from "../../assets/img/auth/background-data-value.png";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 100,
    height: 130,
    marginLeft: "auto",
    marginRight: "auto",
  },
});

const PdfTimeSheet = ({ detail }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image style={styles.logo} src={logo} />
      <DetailPdfTitle title="NINA - Report Hours" />
      <DetailPdfNo detail={detail} />
      <DetailPdfTo detail={detail} />
      <DetailPdfItemsTable detail={detail} />
    </Page>
  </Document>
);

export default PdfTimeSheet;
